import React from "react";
import { useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import Documents from "../../components/templates/Documents";

const EmployeeDocuments = () => {
  let { branchId } = useParams();
  let location = useLocation();
  const isAdmin = location.pathname.includes("admin");

  const activeEmployee = useSelector(
    (state) => state.employeeDetails.activeEmployee
  );
  const branch_id =
    isAdmin &&
    activeEmployee.active_branches &&
    activeEmployee.active_branches[0]
      ? activeEmployee.active_branches[0].id
      : !isAdmin
      ? branchId
      : null;
  return (
    <Documents
      resource={"employees"}
      action={"editor"}
      branch_id={branch_id}
      entityId={activeEmployee.id}
    />
  );
};

export default EmployeeDocuments;
